export default "__VITE_ASSET__xRRhqWNQ__"